import { connect } from 'react-redux';
import Component from './component';
import setOpenNotificationDrawerAction from '../../actions/notificationdrawer/set';
import markAsOpenedAction from '../../actions/notifications/isclicked';
import markAsReadAction from '../../actions/notifications/read';

const mapStateToProps = (state) => ({
  notificationdraweropen: state.notificationdrawer.get('open'),
  notifications: state.notifications.get('data'),
  session: state.session.get('data'),
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenNotificationDrawer: (e, isOpen) => {
    if (e) e.preventDefault();
    dispatch(setOpenNotificationDrawerAction(isOpen));
    if (!isOpen) {
      dispatch(markAsReadAction());
    }
  },
  openingNotification: (e, notification, navigate) => {
    if (e) {
      e.preventDefault();
    }

    dispatch(setOpenNotificationDrawerAction());
    dispatch(markAsOpenedAction(notification, navigate));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
